<template>
    <div v-loading="loading" >
        <div class="text-center"><i class="el-icon-loading" v-if="!ready"></i> </div>
        <div v-show="ready">
            <div class="login-header">
                <img src="../../assets/images/logo_07@2x.png" class="logo">
            </div>
            <div class="position-relative login-body">
                <div class="login-bg">
                    <form class="fm-v clearfix" @submit.prevent="submitForm" action="/">
                        <div class="login-table">
                            <div id="iptUsername">
                                <div class="login-group">
                                    <input v-model="login.id" type="text" autocomplete="off"
                                           placeholder="学号/工号" class="input" value="" required>
                                    <div class="wrapper"><i class="fa fa-user"></i> &nbsp;</div>
                                </div>
                            </div>
                            <div class="spacer"></div>
                            <div id="iptPassword">
                                <div class="login-group">
                                    <input v-model="login.password" type="password"
                                           autocomplete="off"
                                           placeholder="密码" class="input" value="" required>
                                    <div class="wrapper"><i class="fa fa-lock"></i> &nbsp;</div>
                                </div>
                            </div>

                            <div id="submitButton" class="inputSubmitButton">
                                <button type="submit" class="login-btn btn btn-block mt-4"
                                        style="font-size:20px;">登
                                    录
                                </button>
                            </div>

                            <div class="row mt-4 link">
                                <div class="col-6 text-left"><a
                                        href="https://qy.weixin.qq.com/cgi-bin/wap_getnewsmsg?action=get&__biz=MzA3ODY2NzIyMA==&mixuin=MjI5NzgwNzUwODY4Mzk2NzI5OA==&mid=10000401&idx=1&sn=cc1e531ae0d1e9ba119fd0236955fc6a">NetID认证激活</a>
                                </div>
                                <div class="col-6 text-right"><a
                                        href="https://qy.weixin.qq.com/cgi-bin/wap_getnewsmsg?action=get&__biz=MzA3MjY2NjUyNw==&mixuin=MjI5NzgwNzUwODY5Mjk2NzMwMA==&mid=10000389&idx=1&sn=853980d2bc8e8fe567aa4a7aa14960b7&scene=1&pass_ticket=ojKq6OU9sQAQzJfS%2Fwzu8RUjH7z5z%2Be9Nq2mZxyJDBE%3D">忘记密码?</a>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
            <div class="clearfix"></div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex";
    import VueCookie from "vuecookie";
    import qywxCommon from "../../common/mixins/qywxCommon"


    export default {
        name: "sign-in-sufe",
        mixins:[qywxCommon],
        data() {
            return {
                ready:false,
                loading: false,
                login: {
                    id: '',
                    password: ''
                },
            }
        },
        created() {
            const vm = this;
            if (this.$route.query.schoolid == 74942) { //大讲堂跳转

                this.loading = true;
                this.$api('SUFEDJTLOGIN',this.$route.query,1).then((res)=>{
                    VueCookie.set('SUFEDJTLOGIN',1,{expires:'1D'});
                    const ret = res.data.data;
                    if (ret.user) { // 已经登录了，则进入
                        //vm.$messageBox.error('Has User');
                        vm.setUserInfo(ret.user);
                        vm.$router.replace("/");
                    } else {// 如果都不行，则进行网络登录
                        this.loading = false;
                        vm.$messageBox.error(ret.message);
                        vm.$router.replace("/");
                    }
                });
            } else {
                VueCookie.delete('SSOLOGIN');
            }
        },
        mounted(){
            this.qywxHandler();
        },
        computed: {
            ...mapState(['user', 'process']),

        },
        methods: {

            ...mapMutations('user', ['setUserInfo']),
            submitForm() {
                const vm = this;
                if (!vm.login.id) {
                    vm.$message.error('必须要输入学号/工号。');
                } else {
                    vm.$api('SSO', vm.login, true).then(response => {
                        if (response.data.success) {
                            vm.setUserInfo(response.data.data);
                            vm.$router.replace("/");
                        }
                    });
                }
            }
        },
    }
</script>

<style scoped lang="scss">

    @import "../../mobile";

    .login-header {
        padding: 10px;
        height: vw(80);
    }

    .logo {
        vertical-align: center;
        max-width: 100%;
    }

    .login-body {
        height: calc(100vh - #{vw(80)});
        overflow: auto;
        background: url('../../assets/images/bg_07.jpg') no-repeat center;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 10px;

        .login-bg {
            height: 404px;
            background: url('../../assets/images/login_bg.png') no-repeat center;
            margin-top: 10px;
            width: 100%;
            max-width: 440px;
            padding: 0 30px;

            .login-table {
                width: 100%;
                height: 440px;
                padding-top: 130px;

                a {
                    color: #919191;
                    font-size: 12px;
                    text-decoration: none;
                    transition: all 0.2s ease-in;
                }

                .spacer {
                    height: 20px;
                }

                .login-group {
                    height: 40px;
                    position: relative;

                    .input {
                        height: 42px;
                        box-sizing: border-box;
                        border-radius: 3px;
                        border: 1px solid #e6e6e6;
                        color: black;
                        font-size: 14px;
                        width: 100%;
                        padding-left: 34px;
                        transition: all 0.2s ease-in;
                    }

                    .wrapper {
                        color: #e2e2e2;
                        text-align: center;
                        width: 24px;
                        line-height: 40px;
                        position: absolute;
                        top: 1px;
                        left: 8px;
                        transition: all 0.2s ease-in;
                    }
                }

                .login-btn {
                    background-color: #e39949;
                    color: white;
                    transition: all 0.2s ease-in;
                }
            }


        }
    }


    input::-webkit-input-placeholder {
        color: #e2e2e2;
    }

    input::-moz-placeholder { /* Mozilla Firefox 19+ */
        color: #e2e2e2;
    }

    input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
        color: #e2e2e2;
    }

    input:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #e2e2e2;
    }

    input.input:focus {
        border-color: #03a9f4;
        outline: none;
        box-shadow: none;
    }

    input.input:hover {
        border-color: #03a9f4;
        outline: none;
        box-shadow: none;
    }


</style>
